import list from "./list";
import edit from "./edit";

export default {
  namespaced: true,
  modules: { list, edit }
};
